import { useMemo } from 'react';

import { CategoryGroup } from '../../../../common/models/enums/category-group.enum';
import { useTranslations } from '../../../../contexts/LocalizationContext';
import { useScannedRelevosContext } from '../../../../contexts/ScannedRelevosContext';
import { addDays, formatDate } from '../../../../utils/dateHelper';
import { ScannerMode } from '../../../RelevoAssignment/model/enums/scanner-mode.enum';
import { useDepositResultContext } from '../../context/DepositResultContext/DepositResultContext';
import { isAnyItemExpired as checkItemsExpired } from '../../utils/deposit.helper';

export const useDepositSuccessResult = () => {
  const translations = useTranslations();
  const { mode } = useScannedRelevosContext();
  const { deposit, successItems } = useDepositResultContext();

  const itemCounts = useMemo(() => {
    return {
      bowls: successItems.filter((item) => item.category?.categoryGroup === CategoryGroup.BOWLS).length,
      cups: successItems.filter((item) => item.category?.categoryGroup === CategoryGroup.CUPS).length,
      pizzaBoxes: successItems.filter((item) => item.category?.categoryGroup === CategoryGroup.PIZZA).length,
    };
  }, [successItems]);

  const expiryDays = useMemo(() => deposit.expiryDays, [deposit]);

  const expiryDaysText = useMemo(() => {
    if (!expiryDays) return null;
    return `${expiryDays} ${translations('deposit_expiry_days_suffix')} (${formatDate(
      addDays(new Date(), expiryDays),
    )})`;
  }, [expiryDays, translations]);

  const isAnyItemExpired = useMemo(() => checkItemsExpired(successItems), [successItems]);

  const successText = useMemo(
    () =>
      mode === ScannerMode.DEPOSIT_ASSIGN
        ? translations('borrow_deposit_success_items')
        : translations('return_deposit_success_items'),
    [mode, translations],
  );

  const mappedItems = useMemo(() => {
    return successItems.map((item) => {
      return {
        ...item,
        deposit: item.amount.format(deposit.currency),
      };
    });
  }, [successItems, deposit.currency]);

  return {
    itemCounts,
    expiryDays,
    expiryDaysText,
    isAnyItemExpired,
    successText,
    mappedItems,
    mode,
    deposit,
    translations,
  };
};
